/**
 * Horizon RBAC helpers for the React app (`/auth/user-msp` → `user.role`).
 * See server `utils/horizonRoles.js` for matching rules.
 */

/** Normalize Horizon `user.role` (trim + uppercase; padded CHAR-safe). */
export function normalizeHorizonRole(role: string | null | undefined): string {
  return String(role ?? "")
    .trim()
    .toUpperCase();
}

/** True if Horizon `user.role` is ADMIN. */
export function isHorizonAdminRole(role: string | null | undefined): boolean {
  return normalizeHorizonRole(role) === "ADMIN";
}

/** Internal super-admin: AI Thread Observer and assigning ROOT in Theo Users. */
export function isHorizonRootRole(role: string | null | undefined): boolean {
  return normalizeHorizonRole(role) === "ROOT";
}

/** Usage page: ADMIN or ROOT (server omits ROOT-only metrics for non-ROOT viewers). */
export function canAccessUsageAnalytics(role: string | null | undefined): boolean {
  return isHorizonAdminRole(role) || isHorizonRootRole(role);
}



/** Theo Users management (Add / Edit / Delete): ADMIN or ROOT. */
export function canManageTheoUsers(role: string | null | undefined): boolean {
  return isHorizonAdminRole(role) || isHorizonRootRole(role);
}
